/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function () {
  // BLOG POSTS ARROWS
  function scroll(val) {
    $(
      ".shopify-section--blog-posts .scroller, .shopify-section--blog-post-prev-next .scroller"
    ).each(function () {
      $(this)[0].scrollTo({
        top: 0,
        left: val + $(this)[0].scrollLeft,
        behavior: "smooth",
      });
    });
  }

  $(".nav-scroll .next").click(function (e) {
    e.preventDefault();
    scroll(200);
  });

  $(".nav-scroll .prev").click(function (e) {
    e.preventDefault();
    scroll(-200);
  });

  // REVIEWS CAROUSEL
  function setHeight() {
    const height = $(
      ".jdgm-carousel-wrapper .jdgm-carousel__item-container"
    ).innerHeight();
    $(".jdgm-carousel-wrapper .jdgm-carousel__item-container")
      .find(".jdgm-carousel-item ")
      .css("--height", height + "px");
  }
  $(window).resize(function () {
    setHeight();
  });

  // RECHARGE WIDGET
  function show_recharge_text(val) {
    // if (val) {
    //   $('#subs-text').slideDown();
    // } else {
    //   $('#subs-text').slideUp();
    // }
  }
  $("body").on("click", ".rc-widget .rc-radio", function () {
    if (
      $(".rc-widget .rc-radio.subscription-radio").hasClass("rc-radio--active")
    ) {
      show_recharge_text(false);
    } else {
      show_recharge_text(true);
    }
  });

  $(window).on("load", function () {
    setHeight();
    if (
      $(".rc-widget .rc-radio.subscription-radio").hasClass("rc-radio--active")
    ) {
      show_recharge_text(true);
    } else {
      show_recharge_text(false);
    }
  });

  // INVESTOR CENTER

  function investor_center() {
    $(".shopify-section.shopify-section--investor-centre").wrapAll(
      '<div class="investor-center-wrapper--items"></div>'
    );

    $(".investor-center-wrapper--items").wrap(
      '<div class="investor-center-wrapper container vertical-breather"></div>'
    );
    //
    $(".investor-center-wrapper").append(
      '<div class="investor-center-wrapper--sidebar"></div>'
    );

    $(".sidebar-item").appendTo(".investor-center-wrapper--sidebar");

    $(".shopify-section.shopify-section--investor-centre")
      .first()
      .find(".content")
      .show();

    $(".investor-center-wrapper--sidebar")
      .find(".sidebar-item")
      .first()
      .addClass("active")
      .find("ul")
      .show();

    $(".shopify-section.shopify-section--investor-centre").each(function () {
      // console.log($(this));
    });

    $(".sidebar-item").each(function () {
      const id = $(this).find("a.toggle-body").data("toggle");
      $(this)
        .find("a.toggle-body")
        .click(function (e) {
          e.preventDefault();

          $(".content").hide();
          $(".sidebar-item").removeClass("active");
          $(".sidebar-item ul").hide();

          $(`#${id}`).show();
          $(this).parents(".sidebar-item").addClass("active");

          $(this).siblings("ul").show();

          var parent = $(`#${id}.content`);
          // console.log(parent);

          $("html, body").animate(
            {
              scrollTop:
                parent.offset().top -
                $("#shopify-section-header").height() -
                $("#shopify-section-announcement-bar").height(),
            },
            500
          );
        });
    });

    $(".shopify-section--investor-centre-sidebar").appendTo(
      ".investor-center-wrapper--sidebar"
    );
  }

  if (Shopify.designMode) {
    // document.addEventListener("shopify:section:load", investor_center);
    // document.addEventListener("shopify:section:unload", investor_center);
  }
  // investor_center();

  if ($('body[data-template^="page.investor-center"]').length > 0) {
    $(".wrap-this").wrapAll(
      '<div class="investor-center--wrapper container vertical-breather"></div>'
    );
    $(".shopify-section--investor-center--content").wrapAll(
      '<div class="investor-center--content-wrapper"></div>'
    );

    $(".sidebar-item ul li a").click(function (e) {
      const hash = this.hash.substr(1);

      if (hash) {
        e.preventDefault();
        var parent = $(`#${hash}`);

        $("html, body").animate(
          {
            scrollTop:
              parent.offset().top -
              $("#shopify-section-header").height() -
              $("#shopify-section-announcement-bar").height(),
          },
          500
        );
      }
    });

    if ($(window).width() <= 740) {
      if ($(".shopify-section--image-with-text-overlay").length == 0) {
        var parent = $(".investor-center--content-wrapper");

        $("html, body").animate(
          {
            scrollTop:
              parent.offset().top -
              $("#shopify-section-header").height() -
              $("#shopify-section-announcement-bar").height(),
          },
          500
        );
      }
    }
  }
});
const amazonButton = document.querySelectorAll(".amazon-button");
$.get(
  "https://ipinfo.io",
  function (response) {
    amazonButton &&
      amazonButton.forEach((button) => {
        if (response.country == "US" || response.country == "PH")
          button.style.display = "block";
      });
  },
  "jsonp"
);

const amazonButtons = document.querySelectorAll(".amazon-button a");
amazonButtons &&
  amazonButtons.forEach((button) => {
    const product = button.dataset.product;
    const url = button.href;
    button.addEventListener("click", function (e) {
      e.preventDefault();
      gtag("event", "click_amazon", {
        event: "click_amazon",
        value: product,
        debug_mode: false,
        event_callback: function (e) {
          window.location.href = url;
        },
      });
    });
  });

function formatMoney(cents, format) {
  if (typeof cents === "string") cents = cents.replace(".", "");
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "{{amount}}";

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ",";
    decimal = decimal || ".";

    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    var parts = number.split(".");
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function processShippingBar(country, cart_total, show, isCartPage) {
  const shippingBar = document.querySelector("free-shipping-bar");
  const shippingBarText =
  shippingBar && shippingBar.querySelector(".shipping-bar__text");
  let threshold = "";
  if (country == "AU") {
    threshold = parseFloat(window.free_shipping_threshold["AUD"]);
  }
  if (country == "NZ") {
    threshold = parseFloat(window.free_shipping_threshold["NZD"]);
  }
  if (threshold && shippingBarText) {
    total = threshold - parseFloat(cart_total);

   
    if ((isCartPage || country == "AU") && total > 0) { // this code issue on Nz minicart
      const text = window.free_shipping_text.replace(
        "$XX.XX",
        `${window.currency_symbol}${total.toFixed(2)}`
      );
      shippingBar.style.setProperty("--progress", 1 - total / threshold);
      shippingBarText.innerHTML = text;
    }
  }
  if ((isCartPage || country == "AU") && show) { // this code issue on Nz minicart
    const shippingBar = document.querySelector("free-shipping-bar");
    shippingBar && shippingBar.classList.remove("loading");
  }
}

function updateShippingBar(cart_total, show = false) {
  const url = window.location.href;
  const parts = url.split('/');
  const isCartPage = parts.pop() == 'cart';
    if (window.country) {
      processShippingBar(window.country, cart_total, show, isCartPage);
    } else {
      ipInfo().then(async (response) => {
        const results = await response.json();
        if (response.ok) {
          processShippingBar(results.country, cart_total, show, isCartPage);
        }
      });
  }
}
const shippingBar = document.querySelector("free-shipping-bar");
shippingBar && shippingBar.classList.add("loading");
  setTimeout(function () {
    updateShippingBar(window.cart_total);
  }, 1000);
  setTimeout(function () {
    updateShippingBar(window.cart_total);
  }, 2000);
  setTimeout(function () {
    updateShippingBar(window.cart_total);
  }, 3000);
  setTimeout(function () {
    updateShippingBar(window.cart_total, true);
  }, 4000);
  setTimeout(function () {
    updateShippingBar(window.cart_total, true);
  }, 5000);
  setTimeout(function () {
    updateShippingBar(window.cart_total, true);
  }, 10000);

document.addEventListener("cart:updated", function (event) {
  const shippingBar = document.querySelector("free-shipping-bar");
  shippingBar && shippingBar.classList.add("loading");
  var cart = event.detail.cart;
  const total_price = formatMoney(cart.total_price, "{{amount}}");
  setTimeout(function () {
    updateShippingBar(total_price);
  }, 1000);

  if (window.country == "NZ") { // issu on AU mini cart
    setTimeout(function () {
      updateShippingBar(total_price);
    }, 2000);
    setTimeout(function () {
      updateShippingBar(total_price);
    }, 3000);
    setTimeout(function () {
      updateShippingBar(total_price, true);
    }, 4000);
    setTimeout(function () {
      updateShippingBar(total_price, true);
    }, 5000);
    setTimeout(function () {
      updateShippingBar(total_price, true);
    }, 10000);
  }
    
});
